import gql from "graphql-tag";

export const GET_HOME_BUILDING_FACILITIES = gql`
  query GetHomeBuildingFacilities {
    GetHomeBuildingFacilities {
      version
      identifiers {
        key
        value
      }
      facility {
        id
        version
        identifiers {
          key
          value
        }
      }
    }
  }
`;


export const GET_ORDERS = (facilityNumber: string) => gql`
query GetOrders {
    GetOrders(arguments: { facilities: ${JSON.stringify(facilityNumber)}, orderstatuses: "P" }) {
        status
        lines {
            product {
                home {
                    identifiers {
                        key,
                        value
                    },
                    sectionCount
                }
            }
        }
    }
}
`;

export const GET_ORDERS_CACHE = (facilityNumber: string, after: string) => gql`
query GetOrdersCache {
  facilities(where: { identifiers: { key: "iseriesId", value: "${facilityNumber}" } }) {
    edges {
      node {
        ordersConnection(
          first: 370
          where: { orderStatus: "Open" }
          after: "${after}"
        ) {
          totalCount
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              identifiers {
                key
                value
              }
              orderStatus
              orderLinesConnection(
                where: { lineNumber: 1, lineStatus: "Work Order Scheduled" }
              ) {
                edges {
                  node {
                    lineStatus
                    product {
                      home {
                        identifiers {
                          key
                          value
                        }
                        sectionCount
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
